import styled, { css } from 'styled-components';
import { computeDeg } from '../../utils/object-utilities';

const FIXED_COLOR_HOVER_OPACITY = 0.8;
export const DEFAULT_SIZE = '24px';

const ROTATE = 'rotate';
const RADIATE = 'radiate';

const ROTATION_FRAMES = css`
  @keyframes ${ROTATE} {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

const RADIATE_FRAMES = css`
  @keyframes ${RADIATE} {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;

const rotate = rotateCount => {
  const count = typeof rotateCount === 'number' && rotateCount > 0 ? rotateCount : 'infinite';
  return `${ROTATE} 2s linear ${count}`;
};

const radiate = `${RADIATE} 2s linear infinite`;

const isClickable = (onClick, $clickable) => {
  if (typeof $clickable === 'boolean') return $clickable;
  return !!onClick;
};

const isBoolean = value => typeof value === 'boolean' && value;

export const WrapperElement = styled.div.attrs(props => ({
  className: `dsc-icon-wrapper ${props.disabled ? 'disabled' : ''}`
}))`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${({ $fontSize }) => $fontSize || DEFAULT_SIZE};
  border-radius: var(--icon-radius);
  transition: all 0.2s ease-in;

  &[disabled] {
    color: ${({ $fixedColor }) => !$fixedColor && 'var(--icon-default-disabled-color)'};
    svg {
      /* Put disabled color on svg */
      color: ${({ $fixedColor }) => !$fixedColor && 'var(--icon-default-disabled-color)'};
    }
  }
  &:not([disabled]) {
    /* Put color on parent div, and if svg doesn't get a specific color, this one will be inherited (by the currentColor) */
    color: ${({ $fixedColor, onClick, $clickable }) =>
      !$fixedColor &&
      (isClickable(onClick, $clickable) ? 'var(--icon-default-clickable-color)' : 'var(--icon-default-color)')};

    ${({ onClick, $clickable, $fixedColor }) =>
      isClickable(onClick, $clickable) &&
      css`
        /** if icon is fixedColor - apply only hover hover behavior */
        cursor: pointer;

        &:hover {
          opacity: ${$fixedColor ? FIXED_COLOR_HOVER_OPACITY : 'var(--icon-hover-opacity)'};
        }
      `}
  }
  svg {
    font-size: inherit;
    width: 1em;
    height: 1em;
    transform: ${({ $rotate }) => !!$rotate && typeof $rotate !== 'boolean' && `rotate(${computeDeg($rotate)})`};
    ${ROTATION_FRAMES};
    ${RADIATE_FRAMES};
    animation: ${({ $rotate, $radiate, $rotateCount }) =>
      [...(isBoolean($rotate) ? [rotate($rotateCount)] : []), ...(isBoolean($radiate) ? [radiate] : [])].join(',')};
  }
`;
